import { Col, Row } from "../../components/Styled/Container";

const UnresolvedReports = () => {
  return (
    <Col>
      <Row>reports</Row>
    </Col>
  );
};
export default UnresolvedReports;
